import { Component, OnInit } from '@angular/core';
import { DocumentoResultado } from '../../model/documento-resultado';

import { SubirDocumentosService } from '../../services/subir-documentos.service';

@Component({
  selector: 'app-documento-archivo-subir-resultado',
  templateUrl: './documento-archivo-subir-resultado.component.html',
  styleUrls: ['./documento-archivo-subir-resultado.component.css']
})
export class DocumentoArchivoSubirResultadoComponent implements OnInit {


  public resultados : DocumentoResultado[];

  constructor(
    private _subirDocumentosService: SubirDocumentosService
  ) { }

  ngOnInit() {
    this.resultados = [];
  }

  cargarDatos(guid: string){
    this._subirDocumentosService.obteberResultados(guid)
      .subscribe(
      data => { 

        this.resultados = data;
  
    
      },
      err => {
        console.log(err._body);
      });
  }

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/documento-archivo-subir-resultado/documento-archivo-subir-resultado.component.ts